import React from "react";
import { connect } from "react-redux";
import { Provider } from "react-redux";
import store from "../../../../stores/reduxStore";
import * as actions from "../../../../actions/actions";
import * as actionTypes from "../../../../actions/actionTypes";

import {
    UnwrappedForm as SettingsForm,
    mapStateToProps as settingsMapStateToProps,
    mapDispatchToProps as settingsMapDispatchToProps
} from "./settings-card-form";

function mergeProps(stateProps, dispatchProps, ownProps) {
    // https://github.com/reduxjs/react-redux/blob/master/docs/api.md#arguments
    let { args } = ownProps;
    let user;

    // User needs to come from args since it is the team user
    // rather than just the logged in user
    if (args) {
        ({ user } = args);
    }

    stateProps.user = user;

    // getSavedCard is called with no arguments in SettingsForm
    // but to get a team card we need the username, so bind it dynamically
    dispatchProps.getSavedCard = dispatchProps.getSavedCard.bind(
        null,
        user.username
    );

    return Object.assign({}, ownProps, stateProps, dispatchProps);
}

const WrappedForm = connect(
    settingsMapStateToProps,
    {
        ...settingsMapDispatchToProps,
        getSavedCard: actions.stripeGetTeamSavedCard
    },
    mergeProps
)(SettingsForm);

export { WrappedForm };

export default props => (
    <Provider store={store}>
        <WrappedForm {...props} />
    </Provider>
);
